module.exports = __webpack_public_path__ + "img/bed-icon.5af0fd7b.svg";